import type { ReactElement } from 'react';
import { SitePageShell } from '@/shared/ui';
import { MyPageHeader } from '@/widgets/my-page-header';
import { MyPageNav } from '@/widgets/my-page-nav';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';
import { WithdrawPanel } from '@/widgets/withdraw-panel';

/** 회원 탈퇴(/my/withdraw) — 회원정보와 같은 마이페이지 틀 안에서 탈퇴 안내와 확인을 보여 준다. */
export const MyWithdrawPage = (): ReactElement => (
  <SitePageShell header={<SiteHeader />} footer={<SiteFooter />} className="pt-12 sm:pt-16">
    <MyPageHeader />
    <div className="mt-8 grid gap-10 sm:mt-12 lg:grid-cols-[13rem_minmax(0,1fr)] lg:gap-16 xl:grid-cols-[15rem_minmax(0,1fr)] xl:gap-20">
      <MyPageNav activeId="profile" />
      <WithdrawPanel />
    </div>
  </SitePageShell>
);
